/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FertilityReproductiveHealthResponseDto
 */
export interface FertilityReproductiveHealthResponseDto {
    /**
     * Patient identity
     * @type {string}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    patientId: string;
    /**
     * QuestionnaireResponse identifier
     * @type {string}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    questionnaireResponseId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    isInterestedFertilityStatus: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    isTryingToConceive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    hasExperiencedTroubleConceiving?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    troubleConceivingDetails?: string;
    /**
     * Start date of the last period in ISO 8601 date format
     * @type {string}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    lastMenstrualPeriodStartDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    hasRegularPeriods?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    hasNormalMenstrualFlow?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    menstrualFlowDetails?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    hasConsistentCycleTiming?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    menstrualSymptoms?: Array<FertilityReproductiveHealthResponseDtoMenstrualSymptomsEnum>;
    /**
     * 
     * @type {string}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    otherMenstrualSymptoms?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    menopauseOrHormonalTransitionSymptoms?: Array<FertilityReproductiveHealthResponseDtoMenopauseOrHormonalTransitionSymptomsEnum>;
    /**
     * 
     * @type {string}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    otherMenopauseOrHormonalTransitionSymptoms?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    isOnHormoneReplacementTherapy?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    hormoneReplacementTherapyMedicationDetails?: string;
    /**
     * 
     * @type {string}
     * @memberof FertilityReproductiveHealthResponseDto
     */
    additionalReproductiveHealthNotes?: string;
}


/**
 * @export
 */
export const FertilityReproductiveHealthResponseDtoMenstrualSymptomsEnum = {
    MoodSwingsIrritability: 'Mood swings / Irritability',
    Bloating: 'Bloating',
    BreastTenderness: 'Breast tenderness',
    AcneBreakouts: 'Acne breakouts',
    SevereCrampingDysmenorrhea: 'Severe cramping (Dysmenorrhea)'
} as const;
export type FertilityReproductiveHealthResponseDtoMenstrualSymptomsEnum = typeof FertilityReproductiveHealthResponseDtoMenstrualSymptomsEnum[keyof typeof FertilityReproductiveHealthResponseDtoMenstrualSymptomsEnum];

/**
 * @export
 */
export const FertilityReproductiveHealthResponseDtoMenopauseOrHormonalTransitionSymptomsEnum = {
    HotFlashesOrNightSweats: 'Hot flashes or night sweats',
    VaginalDryness: 'Vaginal dryness',
    DecreasedLibidoOrPainfulSex: 'Decreased Libido or Painful Sex',
    SleepDisturbancesInsomnia: 'Sleep disturbances / Insomnia',
    BrainFogDifficultyConcentrating: 'Brain fog / Difficulty concentrating',
    ChangesInSkinAndHairHealth: 'Changes in Skin and Hair Health',
    BoneDensityChanges: 'Bone density changes'
} as const;
export type FertilityReproductiveHealthResponseDtoMenopauseOrHormonalTransitionSymptomsEnum = typeof FertilityReproductiveHealthResponseDtoMenopauseOrHormonalTransitionSymptomsEnum[keyof typeof FertilityReproductiveHealthResponseDtoMenopauseOrHormonalTransitionSymptomsEnum];


/**
 * Check if a given object implements the FertilityReproductiveHealthResponseDto interface.
 */
export function instanceOfFertilityReproductiveHealthResponseDto(value: object): value is FertilityReproductiveHealthResponseDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('isInterestedFertilityStatus' in value) || value['isInterestedFertilityStatus'] === undefined) return false;
    if (!('isTryingToConceive' in value) || value['isTryingToConceive'] === undefined) return false;
    return true;
}

export function FertilityReproductiveHealthResponseDtoFromJSON(json: any): FertilityReproductiveHealthResponseDto {
    return FertilityReproductiveHealthResponseDtoFromJSONTyped(json, false);
}

export function FertilityReproductiveHealthResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FertilityReproductiveHealthResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'questionnaireResponseId': json['questionnaireResponseId'] == null ? undefined : json['questionnaireResponseId'],
        'isInterestedFertilityStatus': json['isInterestedFertilityStatus'],
        'isTryingToConceive': json['isTryingToConceive'],
        'hasExperiencedTroubleConceiving': json['hasExperiencedTroubleConceiving'] == null ? undefined : json['hasExperiencedTroubleConceiving'],
        'troubleConceivingDetails': json['troubleConceivingDetails'] == null ? undefined : json['troubleConceivingDetails'],
        'lastMenstrualPeriodStartDate': json['lastMenstrualPeriodStartDate'] == null ? undefined : json['lastMenstrualPeriodStartDate'],
        'hasRegularPeriods': json['hasRegularPeriods'] == null ? undefined : json['hasRegularPeriods'],
        'hasNormalMenstrualFlow': json['hasNormalMenstrualFlow'] == null ? undefined : json['hasNormalMenstrualFlow'],
        'menstrualFlowDetails': json['menstrualFlowDetails'] == null ? undefined : json['menstrualFlowDetails'],
        'hasConsistentCycleTiming': json['hasConsistentCycleTiming'] == null ? undefined : json['hasConsistentCycleTiming'],
        'menstrualSymptoms': json['menstrualSymptoms'] == null ? undefined : json['menstrualSymptoms'],
        'otherMenstrualSymptoms': json['otherMenstrualSymptoms'] == null ? undefined : json['otherMenstrualSymptoms'],
        'menopauseOrHormonalTransitionSymptoms': json['menopauseOrHormonalTransitionSymptoms'] == null ? undefined : json['menopauseOrHormonalTransitionSymptoms'],
        'otherMenopauseOrHormonalTransitionSymptoms': json['otherMenopauseOrHormonalTransitionSymptoms'] == null ? undefined : json['otherMenopauseOrHormonalTransitionSymptoms'],
        'isOnHormoneReplacementTherapy': json['isOnHormoneReplacementTherapy'] == null ? undefined : json['isOnHormoneReplacementTherapy'],
        'hormoneReplacementTherapyMedicationDetails': json['hormoneReplacementTherapyMedicationDetails'] == null ? undefined : json['hormoneReplacementTherapyMedicationDetails'],
        'additionalReproductiveHealthNotes': json['additionalReproductiveHealthNotes'] == null ? undefined : json['additionalReproductiveHealthNotes'],
    };
}

export function FertilityReproductiveHealthResponseDtoToJSON(json: any): FertilityReproductiveHealthResponseDto {
    return FertilityReproductiveHealthResponseDtoToJSONTyped(json, false);
}

export function FertilityReproductiveHealthResponseDtoToJSONTyped(value?: FertilityReproductiveHealthResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'questionnaireResponseId': value['questionnaireResponseId'],
        'isInterestedFertilityStatus': value['isInterestedFertilityStatus'],
        'isTryingToConceive': value['isTryingToConceive'],
        'hasExperiencedTroubleConceiving': value['hasExperiencedTroubleConceiving'],
        'troubleConceivingDetails': value['troubleConceivingDetails'],
        'lastMenstrualPeriodStartDate': value['lastMenstrualPeriodStartDate'],
        'hasRegularPeriods': value['hasRegularPeriods'],
        'hasNormalMenstrualFlow': value['hasNormalMenstrualFlow'],
        'menstrualFlowDetails': value['menstrualFlowDetails'],
        'hasConsistentCycleTiming': value['hasConsistentCycleTiming'],
        'menstrualSymptoms': value['menstrualSymptoms'],
        'otherMenstrualSymptoms': value['otherMenstrualSymptoms'],
        'menopauseOrHormonalTransitionSymptoms': value['menopauseOrHormonalTransitionSymptoms'],
        'otherMenopauseOrHormonalTransitionSymptoms': value['otherMenopauseOrHormonalTransitionSymptoms'],
        'isOnHormoneReplacementTherapy': value['isOnHormoneReplacementTherapy'],
        'hormoneReplacementTherapyMedicationDetails': value['hormoneReplacementTherapyMedicationDetails'],
        'additionalReproductiveHealthNotes': value['additionalReproductiveHealthNotes'],
    };
}

